/** Group management and Settings follow the Admin role even without the ADMIN category. */
export function visibleAdminChildren<T extends { id: string }>(
  children: T[], isSuperAdmin: boolean, hasAdminCategory: boolean, canManageGroups: boolean
): T[] {
  if (isSuperAdmin) return children;
  children = children.filter((item) => item.id !== 'admin.feedback');
  if (hasAdminCategory) return children;
  return canManageGroups ? children.filter((item) => item.id === 'admin.groups' || item.id === 'admin.settings') : [];
}
